<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            title="订单"
            left-arrow
            @click-left="$router.go(-1)"
        />

        <div v-if="order.id && order.goodsOrderItems">
            <van-card style="background: white;" :num="order.num" @click="goodsClicked"
            >
                <template #tags>
                    <van-tag size="large" plain style="margin-left: 4px;margin-top: 4px;" color="var(--color)">好医推荐</van-tag>
                </template>
                <template #title>
                    <div style="font-size: 16px;">{{order.productName}}</div>
                </template>
                <template #price>
                    <div style="color: var(--color); font-size: 16px; margin-top: 4px;">￥{{(order.priceInCent / 100).toFixed(2)}}</div>
                </template>
                <template #thumb>
                    <van-image :src="baseCdnUrl+'/api/public/goods_'+order.goodsOrderItems[0].goodsId+'-'+order.goodsOrderItems[0].goodsSpecId+'.jpg'"/>
                </template>
                <template #desc>
                    <div style="margin-top: 4px;">{{order.summary}}</div>
                </template>
                <template #footer>
                    <van-button color="var(--color)" size="mini" style="width: 68px" icon="cart" @click.stop="reOrderClicked">再次购买</van-button>
                </template>
            </van-card>

            <div style="margin-top: 10px;">
                <van-notice-bar v-if="order.remarkForUser" scrollable
                                left-icon="volume-o"
                                :text="order.remarkForUser"
                />
                <van-cell title="订单时间" :value="order.createDate" />
                <van-cell title="订单编号" center :value="order.id" >
                    <template #extra>
                        &nbsp;<font-awesome-icon icon="copy" style="color: var(--color); margin-top: 4px;" @click="copyClicked(order.id)"/>
                    </template>
                </van-cell>
                <van-cell title="支付金额">
                    <template #default>
                        <span style="color: var(--color); font-size: 16px;font-weight: 600;">￥{{(order.priceInCent / 100).toFixed(2)}}</span>
                    </template>
                </van-cell>
                <van-cell title="支付状态" :value="order.stateName" >
                    <template #default>
                        <van-tag size="large" :color="order.stateColor">{{ order.stateName }}</van-tag>
                    </template>
                </van-cell>
            </div>

            <van-cell-group title="收货地址" v-if="order.state==='SUCCESS'">
                <van-cell title="姓名" :value="express.name" />
                <van-cell title="手机号" :value="express.mobile" />
                <van-cell title="地址" center :value="express.addressCodeName+express.address" />
                <van-cell v-if="order.state==='SUCCESS'" title="发货状态">
                    <template #default>
                        <van-tag style="" size="large" :type="express.expressStateColor">{{ express.expressStateName }}</van-tag>
                    </template>
                </van-cell>
                <van-cell v-if="express.expressNo" center title="快递单号" :label="express.expressCompany" is-link :url="'https://www.kuaidi100.com/chaxun?com=shunfeng&nu='+express.expressNo">
                    <template #default>
                        <span>{{express.expressNo}}</span>&nbsp;<font-awesome-icon icon="copy" style="color: var(--color); margin-top: 4px;" @click="copyClicked(express.expressNo)"/>
                    </template>
                </van-cell>
            </van-cell-group>

        </div>

    </div>
</template>

<script>
import qs from "qs";
import http, {BASE_CDN_URL, BASE_URL} from "@/utils/http";
import {Notify} from "vant";

export default {
    name: "MyGoodsOrderDetail",
    data() {
        return {
            baseUrl: BASE_URL,
            baseCdnUrl: BASE_CDN_URL,
            loading: false,
            order: {id: null},
            express: null
        };
    },
    mounted() {
        this.order.id = this.$route.query.id?this.$route.query.id:'';
        if(!this.order.id) {
            this.$router.replace("/");
            return;
        }
        this.loadDetail(this.order.id, (order) => {
            var stateColor = '#FF976A';
            switch (order.state) {
                case 'CLOSED':
                    stateColor = '#3C3F41';
                    break;
                case 'SUCCESS':
                    stateColor = '#0CC160';
                    break;
            }
            order.stateColor = stateColor;

            var tagColor = 'default';
            switch (order.express.expressState) {
                case 'SHIPPING':
                    tagColor = 'primary';
                    break;
                case 'RECEIVED':
                    tagColor = 'success';
                    break;
                case 'WAITING':
                    tagColor = 'warning';
                    break;
            }
            order.express.expressStateColor = tagColor;

            this.order = order;
            this.express = order.express;
            // console.log(this.order)
            // console.log(this.product)
        });
    },
    methods: {
        loadDetail(orderId, callback) {
            let payload = qs.stringify({orderId: orderId});
            http.post('/api/personal/goods_order_detail', payload).then(res => {
                if(callback){
                    // console.log(res.data.extra)
                    callback(res.data.extra.order);
                }
                // console.log(res)
            });
        },
        copyClicked(value) {
            this.$copyText(value).then(e => {
                Notify({type: 'success', message: '复制成功'});
            }, function (e) {
            });
        },
        reOrderClicked() {
            window.location.replace(this.baseUrl + '/api/public/wx_oid?url=' + encodeURIComponent(this.baseUrl + '/product_order?id='+this.product.id));
        },
        goodsClicked() {
            this.$router.push('/goods?id='+this.order.goodsOrderItems[0].goodsId)
        }
    },
}
</script>

<style scoped>

</style>